import React, { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios';
import { useReactToPrint } from 'react-to-print';

const Userprofile = () => {
  const [userProfile, setUserProfile] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const getUserProfile = async () => {
    try {
      const response = await axios.get("https://apimlm.bloomitsolutions.in/userroutes/users");
      const empData = response.data;
      setUserProfile(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getUserProfile();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = userProfile.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(userProfile.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const nextPage = () => {
    if (currentPage < pageNumbers.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    });

  return (
    <div>
      <Container>
        <div className='container'>
          <div className='row '>
            <div className='col-lg-12 ' >
              <div className='row ' style={{ display: "flex" }}>
              </div>
              <div className="row ">
                <div className="col-lg-6 mt-4  ">
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-12">
                  <div className="card" ref={componentRef}>
                    <div className="card-header" style={{ backgroundColor: "rgb(0, 156, 0)", color: 'white' }}>
                      <h4> User Profile </h4>
                    </div>
                    <div className="card-body">
                      {/* <div className=""> */}
                        <div className="mb-2">
                          {/* <Button className='rounded-0'>Copy</Button>
                          <Button className='rounded-0'>Excel</Button> */}
                          <Button className='rounded-0'  onClick={handlePrint}>Download PDF</Button>
                          {/* <Button className='rounded-0'>Column visibility</Button> */}
                        </div>
                      {/* </div> */}
                      <form>
                        <div className="card-body" >
                          <div className='table-responsive'>
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th scope='col'>Sl No</th>
                                  <th scope="col">User Id</th>
                                  <th scope="col">Username</th>
                                  <th scope="col">Email</th>
                                  <th scope="col">Wallet Balance</th>
                                  <th scope="col">Role</th>
                                  <th scope="col">Status</th>
                                  <th scope="col">Created At</th>
                                  <th scope="col">Updated At</th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentItems.map((product, index) => (
                                  <tr key={index}>
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td>{product.id}</td>
                                    <td>{product.username}</td>
                                    <td>{product.email}</td>
                                    <td>{product.walletBalance}</td>
                                    <td>{product.role}</td>
                                    <td>{product.status}</td>
                                    <td>{product.createdAt}</td>
                                    <td>{product.updatedAt}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <nav aria-label="...">
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <a className="page-link" onClick={prevPage}>Previous</a>
                  </li>
                  {pageNumbers.map((number) => (
                    <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                      <a className="page-link" onClick={() => paginate(number)}>{number}</a>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === pageNumbers.length ? 'disabled' : ''}`}>
                    <a className="page-link" onClick={nextPage}>Next</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Userprofile;
